// export const LANDING:string:"/";
export enum ROUTE {
  HOME = 'https://mindweal.com/',
  INSTALL = '/install',
  LOGIN = '/',
  SIGNUP = '/signup',
  MIGRATION_SIGNUP = '/migration/signup',
  TRANSFER_SIGNUP = '/transfer/signup',
  THEME = '/theme',
  FORGOTPASSWORD = '/forgotpassword',
  EMAILVERIFICATION = '/emailverification',
  WELCOME = '/welcome',
  RESETPASSWORD = '/resetpassword/:token',
  PREVERIFY = '/preverify',
  DASHBOARD = '/dashboard',
  APPOINTMENTS = '/appointments',
  SELF_SCHEDULING = '/self-scheduling',
  SELF_SCHEDULING_PROVIDER = '/self-scheduling/provider/:providerId',
  MANAGE_APPOINTMENT = '/manage-appointment',

  SUCCESSEMAIL = '/successemail',
  SUCCESSPASSWORD = '/successpassword',
  PROFILE = '/profile',
  PROFILE_ADD_SIBLINGS = '/profile/add/siblings',
  PATIENT_INFORMATION = '/profile/patient',
  GUARDIAN_INFORMATION = '/profile/guardian',
  PROVIDER_INFORMATION = '/profile/provider',
  COUNSELOR_INFORMATION = '/profile/counselor',
  PHARMACY_DETAILS = '/profile/pharmacy',
  INSURANCE_DETAILS = '/profile/insurance',
  SIGN_OUT = '/signout',
  VALIDATE_USER = '/verifyemail/:token',
  TREATMENT = '/treatment',
  REPORTS = '/reports',
  HELP = '/help',
  PROFILE_DASHBOARD = '/profile/dashboard',
  PROFILE_MY_PROFILE = '/profile/my-profile',
  PROFILE_ACCOUNT = '/profile/account',
  /** MM-1123: guardian Settings (Change Password / Change PIN), split out of Account Management */
  PROFILE_SETTINGS = '/profile/settings',
  PROFILE_CARE = '/profile/care',
  PROFILE_BILLING = '/profile/billing',
  DOCUMENTS = '/documents',
  ADMIN_DOCUMENT_REVIEW = '/admin/documents',
  OPEN_POLICY_DOCUMENTS = '/policy/sign/documents',

  MCAT_TEST = '/m-cat',
  MCAT_INTRO = '/m-cat/intro',
  MCAT_ADVISORY = '/m-cat/advisory',
  MCAT_NAVIGATE = '/m-cat/navigate',
  MCAT_ASSESSMENT = '/m-cat/assessment',

  MFSH_NAVIGATE = '/mfsh/navigate',
  MFSH_ASSESSMENT = '/mfsh/assessment',

  WELLBEING = '/wellbeing',
  WELLBEING_ASSESSMENT = '/wellbeing/assessment',

  MEETINGS = '/meetings',
  DIY_POSTS = '/diyposts',
  FAQ = '/faq',
  PRIMARY_GOALS = '/primarygoals',
  WELLNESS_DASHBOARD = '/profile/wellness',
  MCAT_DASHBOARD = '/profile/mcat',
  MCAT_RESULT = '/profile/mcatresult',
  ACCOUNT_MANAGEMENT = '/profile/request',
  UPDATE_EMAIL_PHONE = '/profile/request/contact',
  TRANSFER_ACCOUNT_OWNERSHIP = '/profile/request/transfer',
  DEACTIVATE_ACCOUNT = '/profile/request/deactivate',
  ADMIN_DASHBOARD = '/admin/dashboard',
  ADMIN_APPOINTMENTS = '/admin/appointments',
  ADMIN_APPOINTMENTS_CALENDER = '/admin/appointments/calendar',
  ADMIN_APPOINTMENTS_CALENDER_CLINICAL = '/admin/appointments/calendar/clinical',
  ADMIN_APPOINTMENTS_CALENDER_ADHD = '/admin/appointments/calendar/adhd',
  ADMIN_PATIENT_INFO = '/admin/patientinfo',
  ADMIN_PATIENT_PROFILE = '/admin/patientprofile',

  ADMIN_PATIENT_INFORMATION = '/admin/patientprofile/patient',
  ADMIN_GUARDIAN_INFORMATION = '/admin/patientprofile/guardian',
  ADMIN_PROVIDER_INFORMATION = '/admin/patientprofile/provider',
  ADMIN_COUNSELOR_INFORMATION = '/admin/patientprofile/counselor',
  ADMIN_PHARMACY_DETAILS = '/admin/patientprofile/pharmacy',
  ADMIN_INSURANCE_DETAILS = '/admin/patientprofile/insurance',
  ADMIN_MESSAGES = '/admin/messages',
  ADMIN_APPOINTMENT_DETAILS = '/admin/appointment',
  SYSTEM_VITALS = '/vitals',
  ADMIN_PROFILE = '/admin/profile',
  ADMIN_TASKLIST = '/admin/tasklist',
  ADMIN_OFFICE_LIST = '/admin/officelist',
  ADMIN_USER_OFFICE_LIST = '/admin/userofficelist',
  ADMIN_PATIENT_REPORT = '/admin/patient/report',
  ADMIN_JOBS_REPORT = '/admin/jobs/report',
  APPLICATION_HEALTH = '/admin/application/health',
  ADMIN_PATIENT_ONBOARDING = '/admin/patient/onboarding',
  ADMIN_CONVERSATION_LIST = '/admin/conversations',
  ADMIN_ACCOUNT_MANAGEMENT_REQUEST = '/admin/requests',
  ADMIN_UPDATE_EMAIL_PHONE = '/admin/request/contact',
  ADMIN_TRANSFER_ACCOUNT_OWNERSHIP = '/admin/request/transfer',
  ADMIN_DEACTIVATE_ACCOUNT = '/admin/request/deactivate',
  ADMIN_USER_MANAGEMENT = '/admin/users',
  ADMIN_USER_CREATE = '/admin/users/create',
  ADMIN_MDAC_OPTION1 = '/admin/mdac/configure',
  ADMIN_MDAC_OPTION2 = '/admin/mdac/reports/officelist',
  ADMIN_MDAC_FEEDBACK_RATING = '/admin/mdac/feedback-rating',
  ADMIN_MDAC_SOURCE_DASHBOARD = '/admin/mdac/source-dashboard',
  ADMIN_MDAC_MISSLENIOUS = '/admin/mdac/misslenious',
  WELLNESS_ADMIN_DASHBOARD = '/wellness-admin-dashboard',
  IWISE_ADMIN_DASHBOARD = '/iwise-admin-dashboard',
  ADMIN_MANAGE_ROLES = '/admin/manage/roles',

  ADMIN_PRACTICE_USER_MANAGEMENT = '/admin/practice/user-management',
  ADMIN_PRACTICE_MANAGE_ROLES_AND_PERMISSIONS = '/admin/practice/manage/roles-permissions',
  ADMIN_PRACTICE_MANAGE_USERS_LIST = '/admin/practice/manage/users-list',

  ADMIN_PRACTICE_MANAGE_OFFICES = '/admin/practice/manage/offices',
  ADMIN_PRACTICE_MANAGE_OFFICES_LOCATIONS = '/admin/practice/manage/offices/locations',

  ADMIN_PRACTICE_APPOINTMENT_PROFILES = '/admin/practice/manage/appointment-profiles',
  ADMIN_PRACTICE_APPOINTMENT_PROFILE_MAPPING = '/admin/practice/manage/appointment-profile-mapping',
  /** MM-1168: manual DrChrono calendar sync per office + provider. */
  ADMIN_PRACTICE_SYNC_CALENDAR = '/admin/practice/manage/offices/sync-calendar',
  /** MM-1169: System Monitoring - automated sync jobs and their latest runs. */
  ADMIN_SYNC_JOBS = '/admin/sync-jobs',
}
